import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import './subscriptions.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar'
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import ViewCustomerModal from './customers-list/viewCustomers';


const tableHeaderColumnData = [
    {
      dataField: 'first_name', text: 'First name', sort: true
    },
    {
      dataField: 'last_name', text: 'Last name', sort: true 
    },
    {
      dataField: 'primary_phone', text: 'Primary phone', sort: false
    },
    {
      dataField: 'state', text: 'State', sort: false
    },
    {
      dataField: 'zip', text: 'Zip', sort: false
    },
    {
      dataField: 'address', text: 'Address', sort: false
    },
    {
      dataField: 'date_of_create', text: 'Date of Create', sort: false
    },
    {
      dataField: 'actions', text: 'Actions', sort: false, formatter:(cell,row)=>{
        return (
            <span>
                <button className="btn m-btn--pill  btn-success btn-sm px-3 py-1 my-2" data-toggle="modal" data-target="#view_customer_modal">View Details</button>
                {cell}
            </span>
        )
    }
    }
  ];
const contentData= [{first_name:'dfsdfsd',last_name:'45435',primary_phone:'sfdsfsd'},{first_name:'dfsdfsd',last_name:'45435',primary_phone:'sfdsfsd'},{first_name:'dfsdfsd',last_name:'45435',primary_phone:'sfdsfsd'},{first_name:'dfsdfsd',last_name:'45435',primary_phone:'sfdsfsd'}];

class Subscriptions extends Component {
    constructor(props) {
        super(props);
      }

  render() {
    return (
        <div className="m-grid m-grid--hor m-grid--root m-page" style={{ minHeight: '100vh'}}>
        <body className="m-page--fluid m--skin- m-content--skin-light2 m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--skin-dark m-aside-left--fixed m-aside-left--offcanvas m-footer--push m-aside--offcanvas-default">
		<div className="m-grid m-grid--hor m-grid--root m-page">
			<header id="m_header" className="m-grid__item    m-header " m-minimize-offset="200" m-minimize-mobile-offset="200">
				<div className="m-container m-container--fluid m-container--full-height">
					<div className="m-stack m-stack--ver m-stack--desktop">
						<div className="m-stack__item m-brand  m-brand--skin-dark ">
							<div className="m-stack m-stack--ver m-stack--general">
								<div className="m-stack__item m-stack__item--middle m-brand__logo">
									<a href="index.html" className="m-brand__logo-wrapper">
										<img alt="" src="../../../assets/app/media/img/petpos-white.png" style={{width:'80px'}}/>
									</a>
								</div>
								<div className="m-stack__item m-stack__item--middle m-brand__tools">
									<a href="" id="m_aside_left_minimize_toggle" className="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-desktop-inline-block">
										<span></span>
									</a>
									<a href="" id="m_aside_left_offcanvas_toggle" className="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-tablet-and-mobile-inline-block">
										<span></span>
									</a>
									<a id="m_aside_header_menu_mobile_toggle" href="" className="m-brand__icon m-brand__toggler m--visible-tablet-and-mobile-inline-block">
										<span></span>
									</a>
									<a id="m_aside_header_topbar_mobile_toggle" href="" className="m-brand__icon m--visible-tablet-and-mobile-inline-block">
										<i className="flaticon-more"></i>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>
			<div className="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
				<button className="m-aside-left-close  m-aside-left-close--skin-dark " id="m_aside_left_close_btn">
					<i className="la la-close"></i>
				</button>
                <div id="m_aside_left" className="m-grid__item	m-aside-left  m-aside-left--skin-dark ">
					<div id="m_ver_menu" className="m-aside-menu  m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark " m-menu-vertical="1" m-menu-scrollable="1" m-menu-dropdown-timeout="500" style={{position: 'relative'}}>
						<ul className="m-menu__nav  m-menu__nav--dropdown-submenu-arrow ">
							<li className="m-menu__item  m-menu__item--active" aria-haspopup="true">
								<a href="index.html" className="m-menu__link ">
									<i className="m-menu__link-icon flaticon-line-graph"></i>
									<span className="m-menu__link-title">
										<span className="m-menu__link-wrap">
											<span className="m-menu__link-text">Dashboard</span>
											<span className="m-menu__link-badge">
												<span className="m-badge m-badge--danger">2</span>
											</span>
										</span>
									</span>
								</a>
							</li>
							<li className="m-menu__section ">
								<h4 className="m-menu__section-text">Components</h4>
								<i className="m-menu__section-icon flaticon-more-v3"></i>
							</li>
							<li className="m-menu__item  m-menu__item--submenu" aria-haspopup="true" m-menu-submenu-toggle="hover">
								<a href="" className="m-menu__link m-menu__toggle">
									<i className="m-menu__link-icon flaticon-paper-plane"></i>
									<span className="m-menu__link-text">Subscriptions</span>
									<i className="m-menu__ver-arrow la la-angle-right"></i>
								</a>
							</li>
							<li className="m-menu__item  m-menu__item--submenu" aria-haspopup="true" m-menu-submenu-toggle="hover">
								<a href="" className="m-menu__link m-menu__toggle">
									<i className="m-menu__link-icon flaticon-users"></i>
									<span className="m-menu__link-text">Users</span>
									<i className="m-menu__ver-arrow la la-angle-right"></i>
								</a>
							</li>
							<li className="m-menu__item  m-menu__item--submenu" aria-haspopup="true" m-menu-submenu-toggle="hover">
								<a href="" className="m-menu__link m-menu__toggle">
									<i className="m-menu__link-icon flaticon-graph"></i>
									<span className="m-menu__link-text">Sales</span>
									<i className="m-menu__ver-arrow la la-angle-right"></i>
								</a>
							</li>
						</ul>
					</div>
				</div>
				<div className="m-grid__item m-grid__item--fluid m-wrapper">
					<div className="m-subheader ">
						<div className="d-flex align-items-center">
							<div className="mr-auto">
								<h3 className="m-subheader__title ">Dashboard</h3>
							</div>
						</div>
					</div>
                    <div className="m-content">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="row">
                                    <div className="col-md-6 col-lg-3">
                                        <div className="m-portlet m-portlet--bordered-semi m-portlet--full-height">
                                            <div className="card-body">
                                                <div className="media d-flex align-items-center ">
                                                    <div className="mr-4 rounded-circle bg-info sr-icon-box text-light">
                                                        <i className="flaticon-clipboard"></i>
                                                    </div>
                                                    <div className="media-body common">
                                                        <h4 className="mb-0">No of Medical Records</h4>
                                                        <span><small className="text-muted">10,523</small></span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xl-12">
                                                        <button type="button" className="btn m-btn--pill btn-sm btn-secondary active m-btn m-btn--custom float-right">View Details</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-lg-3">
                                        <div className="m-portlet m-portlet--bordered-semi m-portlet--full-height">
                                            <div className="card-body">
                                                <div className="media d-flex align-items-center ">
                                                    <div className="mr-4 rounded-circle bg-info sr-icon-box text-light">
                                                        <i className="flaticon-notes"></i>
                                                    </div>
                                                    <div className="media-body common">
                                                        <h4 className="mb-0">No of Contracts</h4>
                                                        <span><small className="text-muted">10,523</small></span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xl-12">
                                                        <button type="button" className="btn m-btn--pill btn-sm btn-secondary active m-btn m-btn--custom float-right">View Details</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-lg-3">
                                        <div className="m-portlet m-portlet--bordered-semi m-portlet--full-height">
                                            <div className="card-body">
                                                <div className="media d-flex align-items-center ">
                                                    <div className="mr-4 rounded-circle bg-info sr-icon-box text-light">
                                                        <i className="flaticon-list-3"></i>
                                                    </div>
                                                    <div className="media-body common">
                                                        <h4 className="mb-0">No of Treatments</h4>
                                                        <span><small className="text-muted">99,858</small></span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xl-12">
                                                        <button type="button" className="btn m-btn--pill btn-sm btn-secondary active m-btn m-btn--custom float-right">View Details</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-lg-3">
                                        <div className="m-portlet m-portlet--bordered-semi m-portlet--full-height">
                                            <div className="card-body">
                                                <div className="media d-flex align-items-center ">
                                                    <div className="mr-4 rounded-circle bg-info sr-icon-box text-light">
                                                        <i className="flaticon-stopwatch"></i>
                                                    </div>
                                                    <div className="media-body common">
                                                        <h4 className="mb-0">No of Calculators</h4>
                                                        <span><small className="text-muted">99,858</small></span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xl-12">
                                                        <button type="button" className="btn m-btn--pill btn-sm btn-secondary active m-btn m-btn--custom float-right">View Details</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-lg-3">
                                        <div className="m-portlet m-portlet--bordered-semi m-portlet--full-height">
                                            <div className="card-body">
                                                <div className="media d-flex align-items-center ">
                                                    <div className="mr-4 rounded-circle bg-info sr-icon-box text-light">
                                                        <i className="flaticon-statistics"></i>
                                                    </div>
                                                    <div className="media-body common">
                                                        <h4 className="mb-0">On going Treatments</h4>
                                                        <span><small className="text-muted">99,858</small></span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xl-12">
                                                        <button type="button" className="btn m-btn--pill btn-sm btn-secondary active m-btn m-btn--custom float-right">View Details</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-lg-3">
                                        <div className="m-portlet m-portlet--bordered-semi m-portlet--full-height">
                                            <div className="card-body">
                                                <div className="media d-flex align-items-center ">
                                                    <div className="mr-4 rounded-circle bg-info sr-icon-box text-light">
                                                        <i className="flaticon-music-1"></i>
                                                    </div>
                                                    <div className="media-body common">
                                                        <h4 className="mb-0">Pending Treatments</h4>
                                                        <span><small className="text-muted">99,858</small></span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xl-12">
                                                        <button type="button" className="btn m-btn--pill btn-sm btn-secondary active m-btn m-btn--custom float-right">View Details</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-lg-3">
                                        <div className="m-portlet m-portlet--bordered-semi m-portlet--full-height">
                                            <div className="card-body">
                                                <div className="media d-flex align-items-center ">
                                                    <div className="mr-4 rounded-circle bg-info sr-icon-box text-light">
                                                        <i className="flaticon-folder-1"></i>
                                                    </div>
                                                    <div className="media-body common">
                                                        <h4 className="mb-0">Old Treatments</h4>
                                                        <span><small className="text-muted">99,858</small></span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xl-12">
                                                        <button type="button" className="btn m-btn--pill btn-sm btn-secondary active m-btn m-btn--custom float-right">View Details</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-8">
                                <div className="card card-shadow mb-4 ">
                                    <div className="card-header border-0">
                                        <div className="custom-title-wrap bar-danger">
                                            <div className="custom-title custom-mob">
                                                Petshop Details
                                                <ul className="nav nav-pills nav-pill-turquoise nav-pill-custom nav-pills-sm float-right " id="pills-tab" role="tablist">
                                                    <li className="nav-item">
                                                        <a className="nav-link active show" id="pills-petshop-tab" data-toggle="pill" href="#pills-petshop" role="tab" aria-controls="pills-petshop" aria-selected="true">Petshop Details</a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <div className="m-dropdown m-dropdown--inline m-dropdown--arrow m-dropdown--align-left" data-dropdown-toggle="click">
															<a href="#" className="nav-link m-dropdown__toggle btn dropdown-toggle" role="tab" aria-controls="" aria-selected="false" data-toggle="pill">
																Breeds
															</a>
															<div className="m-dropdown__wrapper">
																<span className="m-dropdown__arrow m-dropdown__arrow--left"></span>
																<div className="m-dropdown__inner"  >
																	<div className="m-dropdown__body">
																		<div className="m-dropdown__content">
                                                                            <ul className="m-nav">
                                                                                <li className="m-nav__section m-nav__section--first">
                                                                                    <span className="m-nav__section-text">
                                                                                        Select Animal Type
                                                                                    </span>
                                                                                </li>
                                                                                <li>
                                                                                    <a className="nav-link" data-toggle="pill" href="#pills-breed-types">Dog</a>
                                                                                </li>
                                                                                <li>
                                                                                    <a className="nav-link" data-toggle="pill" href="#pills-breed-types">Cat</a>
                                                                                </li>
                                                                                <li>
                                                                                    <a className="nav-link" data-toggle="pill" href="#pills-breed-types">Monkey</a>
                                                                                </li>
                                                                                <li>
                                                                                    <a className="nav-link" data-toggle="pill" href="#pills-breed-types">Parrots</a>
                                                                                </li>
                                                                                <li>
                                                                                    <a className="nav-link" data-toggle="pill" href="#pills-breed-types">Pig</a>
                                                                                </li>
                                                                                <li>
                                                                                    <a className="nav-link" data-toggle="pill" href="#pills-breed-types">Rabbits</a>
                                                                                </li>
                                                                            </ul> 
																		</div>  
        															</div>
																</div>
															</div>
														</div>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a className="nav-link" id="pills-registration-types-tab" data-toggle="pill" href="#pills-registration-types" role="tab" aria-controls="pills-registration-types" aria-selected="false">Registration Types</a>
                                                    </li> 
                                                    <li className="nav-item">
                                                        <a className="nav-link" id="pills-animal-types-tab" data-toggle="pill" href="#pills-animal-types" role="tab" aria-controls="pills-animal-types-tab" aria-selected="false">Animal Types</a>
                                                    </li>                                                 
                                                </ul>                                              														
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content" id="pills-tabContent">
                                            <div className="tab-pane fade active show" id="pills-petshop" role="tabpanel" aria-labelledby="pills-petshop-tab">
                                                <div className="row m--align-center">
                                                    <div className="col-xl-12">
                                                        <img src="https://s3.amazonaws.com/uploads.development.petpos/uploads/4/logo/e20702d5a9a892aad6e4f0fe4cf605671539858350714.png" className="m-width-15rem" alt=""/>
                                                    </div>
                                                </div>
                                                <div className="col-xl-12">
                                                    <div className="m-widget4">
                                                        <div className="m-widget4__item">
                                                            <span className="m-widget4__sub">
                                                            <i className="fas fa-link mr-2"></i>
                                                            <span><strong>Domain name: </strong></span>lakshanshop1.petpos.com</span>
                                                        </div>
                                                        <div className="m-widget4__item">
                                                            <span className="m-widget4__sub">
                                                            <i className="fas fa-user mr-2"></i>
                                                            <span><strong>Owner name: </strong>
                                                            </span>Lakshan Kasun</span>
                                                        </div>
                                                        <div className="m-widget4__item"><span className="m-widget4__sub">
                                                            <i className="fas fa-at mr-2"></i>
                                                            <span><strong>Email: </strong></span>lakshan123+1@gmail.com</span>
                                                        </div>
                                                        <div className="m-widget4__item"><span className="m-widget4__sub">
                                                            <i className="fas fa-phone mr-2"></i>
                                                            <span><strong>Phone number: </strong></span>+94772000919</span>
                                                        </div>
                                                        <div className="m-widget4__item">
                                                            <span className="m-widget4__sub"><i className="fas fa-globe mr-2"></i><span><strong>Country: </strong>
                                                            </span>sri lanka</span>
                                                        </div>
                                                        <div className="m-widget4__item">
                                                            <span className="m-widget4__sub">
                                                                <span>You have disapproved to receive our newsletter</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tab-pane fade" id="pills-registration-types" role="tabpanel" aria-labelledby="pills-registration-types-tab">
                                                <ul className="list-unstyled mb-0 list-widget">
                                                    <li>
                                                        <div className="media mb-4">
                                                            <div className="media-body list-widget-border">
                                                                <div className="float-left">
                                                                    <h6 className="text-uppercase mb-0">Type: <span>Reg type1</span></h6>
                                                                    <small className="text-muted">Date of Create: 2018-12-12 1:17:00 pm</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="media mb-4">
                                                            <div className="media-body list-widget-border">
                                                                <div className="float-left">
                                                                    <h6 className="text-uppercase mb-0">Type: <span>Reg type2</span></h6>
                                                                    <small className="text-muted">Date of Create: 2018-12-18 1:25:00 pm</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="media mb-3">
                                                            <div className="media-body list-widget-border">
                                                                <div className="float-left">
                                                                    <h6 className="text-uppercase mb-0">Type: <span>Reg type3</span></h6>
                                                                    <small className="text-muted">Date of Create: 2018-12-25 1:48:00 pm</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="tab-pane fade" id="pills-animal-types" role="tabpanel" aria-labelledby="pills-animal-types-tab">
                                                <ul className="list-unstyled mb-0 list-widget">
                                                    <li>
                                                        <div className="media mb-4">
                                                            <div className="media-body list-widget-border">
                                                                <div className="float-left">
                                                                    <h6 className="text-uppercase mb-0">Animal Type: <span>Dog</span></h6>
                                                                    <small className="text-muted">Date of Create: 2018-12-12 1:17:00 pm</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="media mb-4">
                                                            <div className="media-body list-widget-border">
                                                                <div className="float-left">
                                                                    <h6 className="text-uppercase mb-0">Animal Type: <span>Cat</span></h6>
                                                                    <small className="text-muted">Date of Create: 2018-12-18 1:25:00 pm</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="media mb-3">
                                                            <div className="media-body list-widget-border">
                                                                <div className="float-left">
                                                                    <h6 className="text-uppercase mb-0">Animal Type: <span>Monkey</span></h6>
                                                                    <small className="text-muted">Date of Create: 2018-12-25 1:48:00 pm</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="tab-pane fade" id="pills-breed-types" role="tabpanel" aria-labelledby="pills-breed-types-tab">
                                                <ul className="list-unstyled mb-0 list-widget">
                                                    <li>
                                                        <div className="media mb-4">
                                                            <div className="media-body list-widget-border">
                                                                <div className="float-left">
                                                                    <h6 className="text-uppercase mb-0">Breed Type: <span>boxer</span></h6>
                                                                    <small className="text-muted">Date of Create: 2018-12-12 1:17:00 pm</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="media mb-4">
                                                            <div className="media-body list-widget-border">
                                                                <div className="float-left">
                                                                    <h6 className="text-uppercase mb-0">Breed Type: <span>boxer</span></h6>
                                                                    <small className="text-muted">Date of Create: 2018-12-18 1:25:00 pm</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="media mb-3">
                                                            <div className="media-body list-widget-border">
                                                                <div className="float-left">
                                                                    <h6 className="text-uppercase mb-0">Breed Type: <span>boxer</span></h6>
                                                                    <small className="text-muted">Date of Create: 2018-12-25 1:48:00 pm</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
							        </div>
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card card-shadow mb-4 ">
                                    <div className="card-header border-0">
                                        <div className="custom-title-wrap bar-danger">
                                            <div className="custom-title">
                                                Users
                                            </div>
                                        </div>
                                    </div>
                                    <PerfectScrollbar>
                                    <div className="card-body" style={{maxHeight:'440px'}}>                
                                        <ul className="list-unstyled mb-0 list-widget">
                                            <li>
                                                <div className="media mb-4">
                                                    <img className="mr-3 rounded-circle m-width-50" src="../../../assets/app/media/img/users/100_1.jpg" alt=" "/>
                                                    <div className="media-body list-widget-border">
                                                        <div className="float-left">
                                                            <h6 className="text-uppercase mb-0">shirley hoe</h6>
                                                            <small className="text-muted">Emp no. 87551</small>
                                                            <br/>
                                                            <span className="text-muted">E:chamoya@gmail.com</span>
                                                        </div>
                                                        <div className=" float-right">
                                                            <strong>2 hours ago</strong>
                                                        </div>
                                                    </div>

                                                </div>
                                            </li>
                                            <li>
                                                <div className="media mb-4">
                                                    <img className="mr-3 rounded-circle m-width-50" src="../../../assets/app/media/img/users/user1.jpg" alt=" "/>
                                                    <div className="media-body list-widget-border">
                                                        <div className="float-left">
                                                            <h6 className="text-uppercase mb-0">jonna pinedda</h6>
                                                            <small className="text-muted">Emp no. 87551</small>
                                                            <br/>
                                                            <span className="text-muted">E:chamoya@gmail.com</span>
                                                        </div>
                                                        <div className=" float-right">
                                                            <strong>28 min ago</strong>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="media mb-4">
                                                    <img className="mr-3 rounded-circle m-width-50" src="../../../assets/app/media/img/users/user1.jpg" alt=" "/>
                                                    <div className="media-body list-widget-border">
                                                        <div className="float-left">
                                                            <h6 className="text-uppercase mb-0">jonna pinedda</h6>
                                                            <small className="text-muted">Emp no. 87551</small>
                                                            <br/>
                                                            <span className="text-muted">E:chamoya@gmail.com</span>
                                                        </div>
                                                        <div className=" float-right">
                                                            <strong>28 min ago</strong>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="media mb-4">
                                                    <img className="mr-3 rounded-circle m-width-50" src="../../../assets/app/media/img/users/user1.jpg" alt=" "/>
                                                    <div className="media-body list-widget-border">
                                                        <div className="float-left">
                                                            <h6 className="text-uppercase mb-0">jonna pinedda</h6>
                                                            <small className="text-muted">Emp no. 87551</small>
                                                            <br/>
                                                            <span className="text-muted">E:chamoya@gmail.com</span>
                                                        </div>
                                                        <div className=" float-right">
                                                            <strong>28 min ago</strong>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="media mb-4">
                                                    <img className="mr-3 rounded-circle m-width-50" src="../../../assets/app/media/img/users/user1.jpg" alt=" "/>
                                                    <div className="media-body list-widget-border">
                                                        <div className="float-left">
                                                            <h6 className="text-uppercase mb-0">jonna pinedda</h6>
                                                            <small className="text-muted">Emp no. 87551</small>
                                                            <br/>
                                                            <span className="text-muted">E:chamoya@gmail.com</span>
                                                        </div>
                                                        <div className=" float-right">
                                                            <strong>28 min ago</strong>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="media mb-4">
                                                    <img className="mr-3 rounded-circle m-width-50" src="../../../assets/app/media/img/users/user1.jpg" alt=" "/>
                                                    <div className="media-body list-widget-border">
                                                        <div className="float-left">
                                                            <h6 className="text-uppercase mb-0">jonna pinedda</h6>
                                                            <small className="text-muted">Emp no. 87551</small>
                                                            <br/>
                                                            <span className="text-muted">E:chamoya@gmail.com</span>
                                                        </div>
                                                        <div className=" float-right">
                                                            <strong>28 min ago</strong>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="media mb-4" style={{color:'#2f3c4b'}}>
                                                    <img className="mr-3 rounded-circle m-width-50" src="../../../assets/app/media/img/users/user3.jpg" alt=" "/>
                                                    <div className="media-body list-widget-border">
                                                        <div className="float-left">
                                                            <h6 className="text-uppercase mb-0">Ranidu Nadeesha</h6>
                                                            <small className="text-muted">Emp no. 87551</small>
                                                            <br/>
                                                            <span className="text-muted">E:chamoya@gmail.com</span>
                                                        </div>
                                                        <div className=" float-right">
                                                            <strong>5 mins ago</strong>
                                                        </div>
                                                    </div>

                                                </div>
                                            </li>
                                            <li>
                                                <div className="media mb-4" style={{color:'#2f3c4b'}}>
                                                    <img className="mr-3 rounded-circle m-width-50" src="../../../assets/app/media/img/users/user3.jpg" alt=" "/>
                                                    <div className="media-body list-widget-border">
                                                        <div className="float-left">
                                                            <h6 className="text-uppercase mb-0">Ranidu Nadeesha</h6>
                                                            <small className="text-muted">Emp no. 87551</small>
                                                            <br/>
                                                            <span className="text-muted">E:chamoya@gmail.com</span>
                                                        </div>
                                                        <div className=" float-right">
                                                            <strong>5 mins ago</strong>
                                                        </div>
                                                    </div>

                                                </div>
                                            </li>
                                            <li>
                                                <div className="media mb-3" style={{color:'#2f3c4b'}}>
                                                    <img className="mr-3 rounded-circle m-width-50" src="../../../assets/app/media/img/users/user3.jpg" alt=" "/>
                                                    <div className="media-body list-widget-border">
                                                        <div className="float-left">
                                                            <h6 className="text-uppercase mb-0">Ranidu Nadeesha</h6>
                                                            <small className="text-muted">Emp no. 87551</small>
                                                            <br/>
                                                            <span className="text-muted">E:chamoya@gmail.com</span>
                                                        </div>
                                                        <div className=" float-right">
                                                            <strong>5 mins ago</strong>
                                                        </div>
                                                    </div>

                                                </div>
                                            </li>
                                        </ul>   
                                    </div>
                                    </PerfectScrollbar>
                                </div>      
                            </div>

                        </div>
                        <div className="row">
                            <div className="col-xl-12" id="subs">
                                <div className="card card-shadow mb-4 ">
                                    <div className="card-header border-0">
                                        <div className="custom-title-wrap bar-danger">
                                            <div className="custom-title">
                                                Customer Details
                                            </div>
                                        </div>
                                    </div>
                                    <PerfectScrollbar>
                                    <div className="card-body" style={{maxHeight:'200px'}}>
                                        <BootstrapTable
                                        keyField="id"
                                        data={contentData}
                                        columns={tableHeaderColumnData}
                                        classes="petTable"
                                        defaultSortDirection="asc" 
                                        hover={true} 
                                        // pagination={ paginationFactory() } 
                                        // filter={ filterFactory() }
                                        />
                                    </div>
                                    </PerfectScrollbar>
                                </div>
                            </div>
                        </div>
                        <ViewCustomerModal/>
                	</div>
		   		 </div>
             </div>
		</div>
    </body>
    </div>


    )
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
});


export default withRouter(connect(mapStateToProps)(Subscriptions));
